export enum InvestmentType {
  Auto, Manual
}
